module.exports = global["Resample"] = require("-!/home/dani/kaiwa/node_modules/imports-loader/index.js?this=>window!/home/dani/kaiwa/node_modules/exports-loader/index.js?Resample!./resampler.js");


//////////////////
// WEBPACK FOOTER
// ./libraries/resampler.js
// module id = 299
// module chunks = 1